export default function priceFormat(price: number|string): string{
        if(typeof price === "string") price = parseFloat(price)
        price = price.toFixed(2)
        price = price.replace('.', ',')
        price = price.replace(" ",".")
        price = price+" €"
        return price
}